import { render, staticRenderFns } from "./CartHistory.vue?vue&type=template&id=67198bd7&"
import script from "./CartHistory.vue?vue&type=script&lang=js&"
export * from "./CartHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports